import Glide from '@glidejs/glide';
import gsap from "gsap";
import config from "../config";

const glideOptions = {
  gap: 0,
  perView: 1,
  dragDistance: false,
  swipeThreshold: false,
  dragThreshold: false,
  peek: {
    before: 0,
    after: 120
  }
}

const GlideInstance = (slider) => new Glide(slider, glideOptions)

const SliderInit = (slider) => {
  let slides = [...slider.querySelectorAll(".glide__slide")];
  let slideDescriptionWrapper = slider.querySelector("#glide-description");
  let slideDescription = slider.querySelector("#glide-description p");

  // remove spacing if 1 slide only
  if (slides.length == 1) {
    glideOptions.peek.after = 0;
    glideOptions.peek.before = 0;
  }

  GlideInstance(slider).mount()
    .on('move', () => {
      gsap.to(slideDescription, {
        opacity: 0,
        duration: 0.15
      })
    })
    .on('move.after', () => {
      let slideCenter = slider.querySelector(".glide__slide--active .post__image-description");

      if (slideCenter.innerHTML == "") {
        gsap.set(slideDescriptionWrapper, {
          opacity: 0,
          display: "none"
        })
      } else {
        slideDescription.innerHTML = slideCenter.innerHTML;
        gsap.set(slideDescriptionWrapper, {
          opacity: 1,
          display: "block"
        })
        gsap.to(slideDescription, {
          opacity: 1,
          duration: 0.15
        })
      };

    })

}

const SliderDestroyOnDesktop = (slider) => {
  let slides = slider.querySelector(".glide__slides");
  if (window.innerWidth >= config.breakpointMD) {
    GlideInstance(slider).destroy();
    slides.style.display = "block";
  } else {
    SliderInit(slider);
    slides.style.display = "flex";
  }
}

export { SliderInit, SliderDestroyOnDesktop }